import * as types from '../constants';
import { STATUS } from '../constants';
import { resolve } from '../api';

export const initialDepartmentsState = {
  status: STATUS.IDLE,
  error: null,
  departmentIds: [],
  departmentsById: {},
};

export default (state = initialDepartmentsState, action) => {
  switch (action?.type) {
    case types.LOAD_DEPARTMENTS:
      return {
        ...state,
        status: STATUS.LOADING,
      };
    case resolve(types.LOAD_DEPARTMENTS): {
      const departmentIds = [];
      const departmentsById = {};
      action.payload.forEach((department) => {
        departmentIds.push(department?.uuid);
        departmentsById[department?.uuid] = department;
      });
      return {
        ...state,
        departmentIds,
        departmentsById,
        status: STATUS.LOADED,
      };
    }
    case resolve(types.CREATE_DEPARTMENT): {
      const department = action?.payload;
      const departmentIds = [...state?.departmentIds];
      const departmentsById = { ...state?.departmentsById };
      return {
        ...state,
        departmentIds: departmentIds?.concat(department?.uuid),
        departmentsById: { ...departmentsById, [department?.uuid]: department },
        status: STATUS.LOADED,
      };
    }
    case resolve(types.DELETE_DEPARTMENT):
      return {
        ...state,
        departmentIds: state?.departmentIds?.filter(
          (uuid) => uuid !== action?.uuid,
        ),
        status: STATUS.LOADED,
      };
    case resolve(types.UPDATE_DEPARTMENT): {
      const department = action?.payload;
      return {
        ...state,
        departmentsById: {
          ...state?.departmentsById,
          [department?.uuid]: department,
        },
      };
    }
    default:
      return state;
  }
};
